import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  VEHICLE_VALUATION_PRICE_ADJUSTMENT_RESOURCE,
  type VehicleValuationPriceAdjustmentUpdateBody,
  type VehicleValuationPriceAdjustmentUpdateResponse,
} from "./vehicle-valuation-price-adjustment.types";

export function useVehicleValuationPriceAdjustmentUpdateMutation() {
  const queryClient = useQueryClient();

  return useMutation<
    VehicleValuationPriceAdjustmentUpdateResponse,
    Error,
    VehicleValuationPriceAdjustmentUpdateBody & { uuid: string }
  >({
    mutationFn: async ({ uuid, ...body }) => {
      const response = await alphartisApiAxios.patch<VehicleValuationPriceAdjustmentUpdateResponse>(
        `/v1/${VEHICLE_VALUATION_PRICE_ADJUSTMENT_RESOURCE}/${uuid}`,
        body,
      );

      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [VEHICLE_VALUATION_PRICE_ADJUSTMENT_RESOURCE],
      });
    },
  });
}
